export default "__VITE_ASSET__C042nkV4__"